/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/* Appearing Helpers*/
$.fn.isInViewportAdv = function (partial, hidden, container) {

    var $t = $(this).eq(0),
      t = $t.get(0),
      $w = (container != null ? container : $(window)),
      viewTop = (container != null ? 0 : $w.scrollTop()),
      viewBottom = viewTop + $w.height(),
      _top = $t.offset().top,
      _bottom = _top + $t.height(),
      compareTop = partial === true ? _bottom : _top,
      compareBottom = partial === true ? _top : _bottom,
      clientSize = hidden === true ? t.offsetWidth * t.offsetHeight : true;
    return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop));
};

$.fn.isInViewportPart = function (_offset) {

    var $t = $(this).eq(0),
      $w = $(window),
      offset = $w.height() * _offset,
      viewTop = $w.scrollTop(),
      viewBottom = viewTop + $w.height(),
      _top = $t.offset().top,
      _bottom = _top + $t.height(),
      compareTop = _bottom,
      compareBottom = _top;
    return ((compareBottom + offset <= viewBottom) && (compareTop - offset  >= viewTop));
};

$.fn.isAppearing = function (_offset, log) {
    var elementTop = jQuery(this).offset().top;
    var elementBottom = elementTop + jQuery(this).outerHeight();
    var elementCenter = elementTop + (jQuery(this).outerHeight() / 2);
    var offset = jQuery(window).height() * _offset;
    var viewportTop = jQuery(window).scrollTop();
    var viewportMiddle = viewportTop + (jQuery(window).height() / 2);
    var viewportBottom = viewportTop + jQuery(window).height();
    if (log) {
        console.log('elementTop', elementTop, 'viewportTop', viewportTop);
        console.log('elementBottom', elementBottom, 'viewportBottom', viewportBottom);
        console.log('offset', offset);
    }
    return elementTop + offset < viewportBottom;
};


/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Theme functions
window.theme = window.theme || {};

theme.cacheSelectors = function () {
  theme.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),
    $window                  : $(window),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

theme.init = function () {
    FastClick.attach(document.body);
    theme.cacheSelectors();
    theme.initResize();
    theme.accessibleNav();
    theme.drawersInit();
    theme.mobileNavToggle();
    theme.productImageSwitch();
    theme.responsiveVideos();
    theme.collectionViews();
    theme.loginForms();
    theme.featuredProductSwitcher();
    theme.parallaxOnScroll();
    theme.initLightbox();
    theme.initAppearing();
    theme.initAppearingBlock();
    theme.animationOnScroll();
    // theme.initSmoothScroll();
};

theme.initResize = function () {
    theme.cache.$window.on('resize', function () {
        theme.cache.mediaWidth = window.innerWidth;
        theme.cache.clientWidth = theme.cache.$window.width();
        theme.cache.clientHeight = theme.cache.$window.height();
    }).resize();
}

theme.initSmoothScroll = function () {
    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    if(theme.cache.mediaWidth < 768 || $('.no-smooth-scroll').length > 0 || isFirefox){
        return false;
    }
    if (window.addEventListener) window.addEventListener('DOMMouseScroll', wheel, false);
    window.onmousewheel = document.onmousewheel = wheel;

    function wheel(event) {
        var delta = 0;
        if (event.wheelDelta) delta = event.wheelDelta / 120;
        else if (event.detail) delta = -event.detail / 3;

        handle(delta);
        if (event.preventDefault) event.preventDefault();
        event.returnValue = false;
    }

    var goUp = true;
    var end = null;
    var interval = null;

    function handle(delta) {
        var animationInterval = 20; //lower is faster
        var scrollSpeed = 20; //lower is faster

        if (end == null) {
            end = $(window).scrollTop();
        }
        end -= 20 * delta;
        goUp = delta > 0;

        if (interval == null) {
            interval = setInterval(function () {
                var scrollTop = $(window).scrollTop();
                var step = Math.round((end - scrollTop) / scrollSpeed);
                if (scrollTop <= 0 ||
                  scrollTop >= $(window).prop("scrollHeight") - $(window).height() ||
                  goUp && step > -1 ||
                  !goUp && step < 1 ) {
                    clearInterval(interval);
                    interval = null;
                    end = null;
                }
                $(window).scrollTop(scrollTop + step );
            }, animationInterval);
        }
    }
}

theme.initLightbox = function () {
    if (!$('[data-lightbox-popup]').length) {
        return false;
    }

    $('[data-lightbox-popup]').magnificPopup({
        type: 'image',
        removalDelay: 500, //delay removal by X to allow out-animation
        callbacks: {
            beforeOpen: function() {
                // just a hack that adds mfp-anim class to markup
                this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim');
                this.st.mainClass = 'mfp-zoom-in';
            }
        },
        closeOnContentClick: true,
        midClick: true
    });
}

theme.animationOnScroll = function () {
    theme.whyLemon = {
        animationScrollFade: $('[data-animation-scroll-fade]'),
        animationImageInCircle: $('.image-in-circle'),
        animationImageFixed: $('[data-creative-fixed-fade-image]')
    }

    if(theme.cache.mediaWidth < 768 || (theme.whyLemon.animationScrollFade.length === 0 && theme.whyLemon.animationImageInCircle.length === 0 && theme.whyLemon.animationImageFixed.length === 0)){
        return false;
    }

    theme.whyLemon.latestKnownScrollY = 0;
    theme.whyLemon.ticking = false;

    theme.whyLemon.requestTick = function() {
        // theme.whyLemon.update();
        if(!theme.whyLemon.ticking) {
            requestAnimationFrame(theme.whyLemon.update);
            // theme.whyLemon.update();
        }
        theme.whyLemon.ticking = true;
    }

    theme.whyLemon.init = function () {
        theme.whyLemon.arrayScrollFade = {
            length: theme.whyLemon.animationScrollFade.length
        }
        if(theme.whyLemon.animationScrollFade.length){
            theme.whyLemon.arrayScrollFade.items = [];
            theme.whyLemon.animationScrollFade.each(function(index, item){
                var el = {
                    el: $(item)
                }
                theme.whyLemon.arrayScrollFade.items.push(el);
            });
        }
        if(theme.whyLemon.animationImageInCircle.length){
            theme.whyLemon.animationCircle = {
                circleInner: theme.whyLemon.animationImageInCircle.find('.image-in-circle__inner'),
                circleCircle: theme.whyLemon.animationImageInCircle.find('.image-in-circle__circle'),
                circleParent: theme.whyLemon.animationImageInCircle.parents('.image-in-circle__parent'),
                circleImage: theme.whyLemon.animationImageInCircle.find('img')
            }
        }
        theme.whyLemon.arrayImageFixed = {
            length: theme.whyLemon.animationImageFixed.length
        }
        if(theme.whyLemon.animationImageFixed.length){
            theme.whyLemon.arrayImageFixed.items = [];
            theme.whyLemon.animationImageFixed.each(function(index, item) {
                var el = {
                    el: $(item),
                    content: $(item).find('.container')
                }
                theme.whyLemon.arrayImageFixed.items.push(el);
            });
        }

        theme.cache.$window.on('scroll', theme.whyLemon.onScroll);
        theme.cache.$window.on('resize', theme.whyLemon.onResize).resize();
        setTimeout(function(){
            theme.cache.$window.scroll();
        }, 20);
    }

    theme.whyLemon.onScroll = function () {
        if(theme.cache.mediaWidth < 768){
            return false
        }
        theme.whyLemon.latestKnownScrollY = theme.cache.$window.scrollTop();
        theme.whyLemon.requestTick();
    }

    theme.whyLemon.onResize = function () {
        if(theme.whyLemon.arrayScrollFade.length){
            for(var index = 0; index < theme.whyLemon.arrayScrollFade.length; index++){
                theme.whyLemon.arrayScrollFade.items[index].topPosition = theme.whyLemon.arrayScrollFade.items[index].el.offset().top;
                theme.whyLemon.arrayScrollFade.items[index].height = theme.whyLemon.arrayScrollFade.items[index].el.height();
            }
        }
        if(typeof theme.whyLemon.animationCircle !== 'undefined'){
            theme.whyLemon.animationCircle.topPosition = theme.whyLemon.animationCircle.circleInner.offset().top;
            theme.whyLemon.animationCircle.parentTopPosition = theme.whyLemon.animationCircle.circleParent.offset().top;
            theme.whyLemon.animationCircle.height = theme.whyLemon.animationCircle.circleCircle.height();
            theme.whyLemon.animationCircle.heightHalf = theme.whyLemon.animationCircle.height / 2;
            theme.whyLemon.animationCircle.parentHeight = theme.whyLemon.animationCircle.circleParent.height();
        }
        if(theme.whyLemon.arrayImageFixed.length){
            for(var index = 0; index < theme.whyLemon.arrayImageFixed.length; index++){
                theme.whyLemon.arrayImageFixed.items[index].topPosition = theme.whyLemon.arrayImageFixed.items[index].el.offset().top;
                theme.whyLemon.arrayImageFixed.items[index].contentTopPosition = theme.whyLemon.arrayImageFixed.items[index].content.offset().top;
                theme.whyLemon.arrayImageFixed.items[index].height = theme.whyLemon.arrayImageFixed.items[index].el.height();
                theme.whyLemon.arrayImageFixed.items[index].contentHeight = theme.whyLemon.arrayImageFixed.items[index].content.height();
                theme.whyLemon.arrayImageFixed.items[index].bottomPosition = theme.whyLemon.arrayImageFixed.items[index].topPosition + theme.whyLemon.arrayImageFixed.items[index].height;
                theme.whyLemon.arrayImageFixed.items[index].half = theme.whyLemon.arrayImageFixed.items[index].topPosition + theme.whyLemon.arrayImageFixed.items[index].height / 2;
            }
        }
    }
    setTimeout(theme.whyLemon.init, 500);

    theme.whyLemon.update = function() {
        theme.whyLemon.ticking = false;

        var scrollTop = theme.whyLemon.latestKnownScrollY;
        var scrollBottom = theme.whyLemon.latestKnownScrollY + theme.cache.clientHeight;

        if(theme.whyLemon.arrayScrollFade.length){
            for(var index = 0; index < theme.whyLemon.arrayScrollFade.length; index++){
                theme.whyLemon.arrayScrollFade.items[index].opacity = 1 - scrollTop / (theme.whyLemon.arrayScrollFade.items[index].topPosition + theme.whyLemon.arrayScrollFade.items[index].height);
                if(theme.whyLemon.arrayScrollFade.items[index].opacity > 1) {
                    theme.whyLemon.arrayScrollFade.items[index].opacity = 1;
                }
                if(theme.whyLemon.arrayScrollFade.items[index].opacity < 0) {
                    theme.whyLemon.arrayScrollFade.items[index].opacity = 0;
                }
                theme.whyLemon.arrayScrollFade.items[index].el.css({
                    opacity: theme.whyLemon.arrayScrollFade.items[index].opacity
                });
            };
        }

        if(typeof theme.whyLemon.animationCircle !== 'undefined'){
            var circleValue = (theme.cache.clientHeight - theme.whyLemon.animationCircle.height) / 2;
            theme.whyLemon.animationCircle.circleOffset = ((theme.whyLemon.animationCircle.topPosition - circleValue) >= scrollTop) ? 0 : scrollTop - (theme.whyLemon.animationCircle.topPosition - circleValue);
            var circleOpacityBottomPos = theme.whyLemon.animationCircle.parentTopPosition + theme.whyLemon.animationCircle.parentHeight + (theme.cache.clientHeight - theme.whyLemon.animationCircle.height) / 2;
            var circleOpacityDiff = Math.max(0, scrollBottom - circleOpacityBottomPos);
            theme.whyLemon.animationCircle.circleOpacity = Math.max(0, (theme.whyLemon.animationCircle.heightHalf - circleOpacityDiff) / theme.whyLemon.animationCircle.heightHalf);

            // console.log('opacDif', circleOpacityDiff, 'opac', circleOpacity);
            // console.log('bottom position', theme.whyLemon.animationCircle.parentTopPosition + theme.whyLemon.animationCircle.parentHeight + (theme.cache.clientHeight - theme.whyLemon.animationCircle.height) / 2, 'top', theme.whyLemon.animationCircle.topPosition, 'pt', theme.whyLemon.animationCircle.parentTopPosition, 'h', theme.whyLemon.animationCircle.parentHeight);
            /*theme.whyLemon.animationCircle.circleOpacity = ((scrollTop + theme.cache.clientHeight) - (theme.whyLemon.animationCircle.parentTopPosition + theme.whyLemon.animationCircle.parentHeight) - 180)/180;
            if(theme.whyLemon.animationCircle.circleOpacity > 0){
                theme.whyLemon.animationCircle.circleOpacity = 1 - theme.whyLemon.animationCircle.circleOpacity;
                if(theme.whyLemon.animationCircle.circleOpacity > 1) {
                    theme.whyLemon.animationCircle.circleOpacity = 1;
                }
                if(theme.whyLemon.animationCircle.circleOpacity < 0) {
                    theme.whyLemon.animationCircle.circleOpacity = 0;
                }
            } else {
                theme.whyLemon.animationCircle.circleOpacity = 1;
            }*/
            if(theme.whyLemon.animationCircle.circleOffset > 0){
                if(!theme.whyLemon.animationCircle.circleInner.hasClass('fixed')){
                    theme.whyLemon.animationCircle.circleInner.addClass('fixed')
                }
            } else {
                if(theme.whyLemon.animationCircle.circleInner.hasClass('fixed')){
                    theme.whyLemon.animationCircle.circleInner.removeClass('fixed')
                }
            }

            theme.whyLemon.animationCircle.circleCircle.css({
                // '-webkit-transform': 'translateY('+theme.whyLemon.animationCircle.circleOffset+'px) translateZ(0px)',
                // 'transform': 'translateY('+theme.whyLemon.animationCircle.circleOffset+'px) translateZ(0px)',
                // 'transform': 'matrix3d(1,0,0.00,0,0.00,1,0.00,0,0,0,1,0,0,'+theme.whyLemon.animationCircle.circleOffset+',0,1)',
                // '-webkit-transform': 'matrix3d(1,0,0.00,0,0.00,1,0.00,0,0,0,1,0,0,'+theme.whyLemon.animationCircle.circleOffset+',0,1)',
                'opacity': theme.whyLemon.animationCircle.circleOpacity
            });
            // var translate = -0.5025 * scrollTop + 100.5025;
            var translate = -0.18 * scrollTop + 160; // 0.025
            var scale = -0.0005 * scrollTop + 1.25; //-0.0013
            // console.log('scale', scale);
            if(scale < 1) {
                scale = 1
            }
            if(translate < 70){
                translate = 70;
            }
            theme.whyLemon.animationCircle.circleImage.css({
                '-webkit-transform': 'scale('+scale+') translate3d(0, '+translate+'px, 0)',
                'transform': 'scale('+scale+') translate3d(0, '+translate+'px, 0)'
                // transform: 'scale('+scale+') translateY('+translate+'px)'
            })
        }

        if(theme.whyLemon.arrayImageFixed.length){
            for(var index = 0; index < theme.whyLemon.arrayImageFixed.length; index++){
                if(scrollTop + theme.cache.clientHeight/2 > theme.whyLemon.arrayImageFixed.items[index].topPosition+theme.cache.clientHeight*0.2){
                    theme.whyLemon.arrayImageFixed.items[index].opacity = 1;
                } else {
                    theme.whyLemon.arrayImageFixed.items[index].opacity = 0;
                }

                if(scrollTop + theme.cache.clientHeight/2 > theme.whyLemon.arrayImageFixed.items[index].contentTopPosition + (theme.whyLemon.arrayImageFixed.items[index].contentHeight)/2){
                    theme.whyLemon.arrayImageFixed.items[index].el.removeClass('fixed');
                } else {
                    theme.whyLemon.arrayImageFixed.items[index].el.addClass('fixed');
                }
                // console.log('scroll', scrollTop + theme.cache.clientHeight/2);
                // console.log('pos', theme.whyLemon.arrayImageFixed.items[index].topPosition+theme.cache.clientHeight/2);

                if(theme.whyLemon.arrayImageFixed.items[index].opacity){
                    theme.whyLemon.arrayImageFixed.items[index].el.addClass('appeared');
                } else {
                    theme.whyLemon.arrayImageFixed.items[index].el.removeClass('appeared');
                }

            };
        }

    }
}

theme.parallaxOnScroll = function () {
    if (theme.cache.mediaWidth < 768 || !$('[data-parallaxed-factor]').length) {
        return false;
    }

    $('[data-parallaxed-factor]').parallaxed({
        type: 'foreground'
    });
}

theme.initAppearing = function () {
    var appearItems = $('[data-appear-text], [data-appear-fade-in], [data-appear-text-group] > *');

    if(appearItems.length === 0){
        return false;
    }

    theme.cache.$window.on('scroll', function() {
        appearItems.not('.is-appeared').each(function(index, item) {
            var el = $(item);
            if (el.isInViewportAdv(true)){
                el.addClass('is-appeared');
            }
        });
    }).scroll();
}

theme.initAppearingBlock = function () {
    var appearItems = $('[data-appear-block], [data-appear-block-desktop]');

    if(appearItems.length === 0){
        return false;
    }

    appearItems.each(function () {
        var el = $(this);
        el.find('> *').each(function (index) {
            var item = $(this);
            if (index > 0) {
                item
                  .attr('data-transition-delay', (index * 0.2) + 's')
                  .css({
                      'transition-delay': (index * 0.2) + 's'
                  });
            }
        });
    });

    theme.cache.$window.on('scroll', function() {
        appearItems.not('.is-appeared').each(function(index, item) {
            var el = $(item);
            if (el.isAppearing(0.3, false)) {
                el.addClass('is-appeared');
            }
        });
    }).scroll();
}

theme.featuredProductSwitcher = function () {
    var $colors = {
      'blue': '#00B2E3',
      'green': '#76C96E',
      'red': '#FF595A',
      'red-light': '#FF8D6B',
      'pink': '#E81F76',
      'pink-light': '#F376C3',
      'turquoise': '#2ED9C3',
      'lavande': '#9578D3',
      'strawberry-pf': '#EE263E',
      'watermelon': '#EB6FBD',
      'watermelon-cherry': '#EB6FBD',
      'coconut-lime': '#01C44F'
    };
    var $main = $('.featured-products-switch__product-items');
    if($main.length){
        $main.each(function () {
            var $container = $(this),
              $switcher = $container.find('.featured-products-switch__switcher'),
              $back = $main.find('.featured-products-switch__background');

            $switcher.on('click', 'a', function (e, data) {
                e.preventDefault();
                // console.log($back);
                var el = $(this),
                  parent = el.parent(),
                  $wrapper = parent.closest('.featured-products-switch__wrapper');
                  $wrapper2 = $('.featured-products-switch__wrapper2');
                  $wrapper3 = $('.product-impressions-v2-wrapper');


                if(parent.hasClass('active')){
                    return false;
                }

                var targetIndex = parent.data('item'),
                    currentIndex = $switcher.find('li.active').data('item');

                $wrapper.find('li').removeClass('active');
                parent.addClass('active').addClass('animate');

                setTimeout(function () {
                    parent.removeClass('animate');
                    var color = parent.data('color');
                    
                    if($back.length){
                        $back.css({'backgroundColor': $colors[color]});
                    }
                }, 500);

                var $captions = $wrapper.find('.featured-products-switch__caption');
                if($captions.length){
                    var $currentCaption = $captions.filter($('.active')),
                        $targetCaption = $captions.filter('[data-item="'+targetIndex+'"]');
                    $currentCaption.addClass('animation-leave');
                    $targetCaption.addClass('animation-leave');

                    setTimeout(function () {
                        $currentCaption.removeClass('active').removeClass('animation-leave');
                        $targetCaption.addClass('active').removeClass('animation-leave');
                    }, 300);
                }

                var $titles = $wrapper.find('.featured-products-switch__title--v3');
                if($titles.length){
                    var $currentTitle = $titles.filter($('.active')),
                      $targetTitle = $titles.filter('[data-item="'+targetIndex+'"]');
                    $currentTitle.addClass('animation-leave');
                    $targetTitle.addClass('animation-leave');

                    setTimeout(function () {
                        $currentTitle.removeClass('active').removeClass('animation-leave');
                        $targetTitle.addClass('active').removeClass('animation-leave');
                    }, 300);
                }

                var $titles2 = $wrapper2.find('.featured-products-switch__title--v4');

                if($titles2.length){
                    var $currentTitle2 = $titles2.filter($('.active')),
                    $targetTitle2 = $titles2.filter('[data-item="'+targetIndex+'"]');
                    $currentTitle2.addClass('animation-leave');
                    $targetTitle2.addClass('animation-leave');

                    setTimeout(function () {
                        $currentTitle2.removeClass('active').removeClass('animation-leave');
                        $targetTitle2.addClass('active').removeClass('animation-leave');
                    }, 300);
                }

                var $titles3 = $wrapper3.find('.product-impressions__content--image');

                if($titles3.length){
                    var $currentTitle3 = $titles3.filter($('.active')),
                    $targetTitle3 = $titles3.filter('[data-item="'+targetIndex+'"]');
                    $currentTitle3.addClass('animation-leave');
                    $targetTitle3.addClass('animation-leave');

                    setTimeout(function () {
                        $currentTitle3.removeClass('active').removeClass('animation-leave');
                        $targetTitle3.addClass('active').removeClass('animation-leave');
                    }, 300);
                }
                
                var $descriptions = $wrapper2.find('.featured-products-switch__description');
                if($descriptions.length){
                    var $currentDescription = $descriptions.filter($('.active')),
                      $targetDescription = $descriptions.filter('[data-item="'+targetIndex+'"]');
                    $currentDescription.addClass('animation-leave');
                    $targetDescription.addClass('animation-leave');

                    setTimeout(function () {
                        $currentDescription.removeClass('active').removeClass('animation-leave');
                        $targetDescription.addClass('active').removeClass('animation-leave');
                    }, 300);
                }
                
                var $images = $wrapper.find('.featured-products-switch__image');
                if($images.length){
                    var $currentImage = $images.filter($('.active')),
                      $targetImage = $images.filter('[data-item="'+targetIndex+'"]');
                    $currentImage.addClass('animation-leave');
                    $targetImage.addClass('animation-leave');

                    setTimeout(function () {
                        $currentImage.removeClass('active').removeClass('animation-leave');
                        $targetImage.addClass('active').removeClass('animation-leave');
                    }, 300);
                }
                
                var $forms = $wrapper.find('.featured-products-switch__add-to-cart-form');
                if($forms.length){
                    var $currentForm = $forms.filter($('.active')),
                      $targetForm = $forms.filter('[data-item="'+targetIndex+'"]');
                    $currentForm.addClass('animation-leave');
                    $targetForm.addClass('animation-leave');

                    setTimeout(function () {
                        $currentForm.removeClass('active').removeClass('animation-leave');
                        $targetForm.addClass('active').removeClass('animation-leave');
                    }, 300);
                }
                if(typeof data === 'undefined' || (typeof data === 'undefined' && !data.skipPushState)){
                    if(parent.data('url')){
                        history.pushState({ url: parent.data('url'), title: parent.data('title'), id: parent.data('product') }, parent.data('title'), parent.data('url'));
                        document.title = parent.data('title');
                    }
                }
            })
        });
    }
    // Add Waypoints to each Featured Products Switch
    var productsSwitchWaypointsFirst = $('.products-switch-first').waypoint({
      handler: function(direction) {
        var color = $(this.element).find('.featured-products-switch__switcher .active').data('color');
        var bg = $('.featured-products-switch__background');
        bg.animate({'backgroundColor': $colors[color]}, 1000);
      }
    })

    var productsSwitchWaypointsNotFirst = $('.products-switch-not-first').waypoint({
      handler: function(direction) {
        var color = $(this.element).find('.featured-products-switch__switcher .active').data('color');
        var bg = $('.featured-products-switch__background');

        if (direction == 'up') {
          var prevProductSwitch = $(this.element).prev();
          color = prevProductSwitch.find('.featured-products-switch__switcher .active').data('color');
        }


        bg.stop(true).animate({'backgroundColor': $colors[color]}, 1000);
      },
      offset: '50%'
    })
    // End Waypoints code

    if($('.featured-products-switch--product-page').length){
        $(window).on("popstate", function(e) {
            var title, id, url
            if(e.originalEvent.state === null) {
                var cont = $('.featured-products-switch--product-page');
                title = cont.data('init-title');
                id = cont.data('init-id');
                url = cont.data('init-url');
            } else {
                title = e.originalEvent.state.title;
                id = e.originalEvent.state.id;
                url = e.originalEvent.state.url;
            }
            console.log(e.originalEvent.state);
            document.title = title;
            $('#change-product-'+id).trigger('click', { skipPushState: true });
        });
    }
};

theme.accessibleNav = function () {
  var $nav = theme.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      theme.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    theme.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

theme.drawersInit = function () {
  theme.LeftDrawer = new theme.Drawers('NavDrawer', 'left');
  
    theme.RightDrawer = new theme.Drawers('CartDrawer', 'right', {
      'onDrawerOpen': ajaxCart.load
    });
  
};

theme.mobileNavToggle = function () {
  theme.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

theme.getHash = function () {
  return window.location.hash;
};

theme.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, theme.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Add to Cart");
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html("Compare at" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
};

theme.productImageSwitch = function () {
  if (theme.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    theme.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      theme.switchImage(newImage, null, theme.cache.$productImage);
    });
  }
};

theme.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

theme.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

theme.collectionViews = function () {
  if (theme.cache.$changeView.length) {
    theme.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

theme.loginForms = function() {
  function showRecoverPasswordForm() {
    theme.cache.$recoverPasswordForm.show();
    theme.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    theme.cache.$recoverPasswordForm.hide();
    theme.cache.$customerLoginForm.show();
  }

  theme.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  theme.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (theme.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

theme.resetPasswordSuccess = function() {
  theme.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
theme.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    theme.cache.$body.trigger('beforeDrawerOpen.theme', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });
    // Use bodyScrollLock fallback to make sure body is locked from scrolling
    var target1 = document.querySelector('#CartDrawer');
    var target2 = document.querySelector('.ajaxcart__inner');
    bodyScrollLock.disableBodyScroll(target2)
    bodyScrollLock.disableBodyScroll(target1)

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Notify the drawer has opened
    theme.cache.$body.trigger('afterDrawerOpen.theme', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    theme.cache.$body.trigger('beforeDrawerClose.theme', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Use bodyScrollLock fallback to make sure body is unlocked to scroll
    var target1 = document.querySelector('#CartDrawer');
    var target2 = document.querySelector('.ajaxcart__inner');
    bodyScrollLock.enableBodyScroll(target2)
    bodyScrollLock.enableBodyScroll(target1)

    // Notify the drawer is closed now
    theme.cache.$body.trigger('afterDrawerClose.theme', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

// Initialize Timber's JS on docready
$(theme.init);

// Animate anchor links scroll position
(function($){
  
  $("a[href^=\\#]").click(function (e) { 
    e.preventDefault(); 
    var dest = $(this).attr('href'); 
    // console.log(dest); 
    if ($(dest).offset() != undefined) {
      $('html,body').animate(
        { 
          scrollTop: $(dest).offset().top 
        }, 'slow'
      );
    } 
  });

})(jQuery);